import { useSelector } from "react-redux";
import MediaQuery from "react-responsive";
import { Link, useSearchParams } from "react-router-dom";
import { useRef } from "react";
import { useTranslation } from "../../../../../../../hooks";
import { CustomSelect } from "../../../../../../../components/ui/CustomSelect/CustomSelect";
import { useDispatchedActions } from "../../../../../../../hooks/useDispatchedActions";
import { PROXY_TYPES } from "../../../../../../../utils/constants";

export const ProxyType = ({ selectedTableType, setSelectedTableType }) => {
  // Dispatch
  const { setActiveProxy, setSelectedFolder } = useDispatchedActions();

  // **State
  const { activeData, proxies } = useSelector((state) => state.content);
  const { proxyNav } = useTranslation().header.menu;
  const { cabinet: { newOrder: { proxyTypeLabel } } } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  // const { width } = useResize();

  const ref = useRef();

  const addToSearch = (value) => {
    searchParams.set("proxyType", value);
    setSearchParams(searchParams);
  };

  const resetFilter = () => {
    searchParams.delete("country");
    searchParams.delete("runningOuts");
    searchParams.delete("description");
    setSearchParams(searchParams);
  };

  const resetFolder = () => {
    setSelectedFolder({ value: null, label: null });
  };

  const desktopHandler = (e, obj) => {
    if (obj?.code === activeData?.proxy?.code) return;

    if (obj?.code === PROXY_TYPES.residential.code) {
      setSelectedTableType("all");
    }

    e.preventDefault();
    setActiveProxy(obj);
    addToSearch(obj?.code);
    resetFilter();
    resetFolder();
  };

  const mobileHandler = (item) => {
    if (item?.code === PROXY_TYPES.residential.code) {
      setSelectedTableType("all");
    }

    setActiveProxy(item);
    addToSearch(item?.code);
    resetFilter();
    resetFolder();
  };

  // useEffect(() => {
  //   if (width > 993) {
  //     return;
  //   }
  //
  //   if (ref.current && activeData?.proxy?.value) {
  //     const defaultValue = proxies?.enabled.find((proxy) => proxy.value === activeData?.proxy?.value) || proxies?.enabled[0];
  //
  //     const currentValue = ref.current.select.getValue();
  //
  //     if (currentValue[0]?.value !== defaultValue?.value) {
  //
  //       ref.current.select.setValue(defaultValue);
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [activeData?.proxy?.value, width]);

  const getProxyTypeName = (proxy) => {
    if (!proxy?.code) return "";

    switch (proxy.code) {
      case PROXY_TYPES.mobile.code:
        return proxyNav?.subNameMobile;
      case PROXY_TYPES.residential.code:
        return proxyNav?.subNameResidential;
      default:
        return `${proxyNav?.subName} ${proxy?.label}`;
    }
  };

  const testProxies = {
    ...proxies,
    ...(process.env.REACT_APP_MODE !== "prod"
      ? {
        enabled: [
          ...(proxies?.enabled || []),
          { code: "RESIDENTIAL", value: "residental", label: "Residental" }
        ]
      }
      : {})
  };

  const filteredProxies = testProxies?.enabled?.filter(({ code }) => {
    if (selectedTableType !== "all") return code !== PROXY_TYPES.residential.code;

    return true;
  });

  return (
    <>
      <MediaQuery minWidth={993}>
        <ul
          className="proxies__advantages"
        >
          {filteredProxies?.map((obj) => (
            <li
              key={obj?.value}
              className={`proxies__advantage  ${
                obj?.value === activeData?.proxy?.value
                  ? "proxies__advantage--active"
                  : ""
              }`}
            >
              <Link
                className={`proxies__link ${
                  obj?.value === activeData?.proxy?.value
                    ? "proxies__link--active"
                    : ""
                }`}
                onClick={(e) => desktopHandler(e, obj)}
              >
                <span className="proxies__link-text">
                  {getProxyTypeName(obj)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </MediaQuery>
      <MediaQuery maxWidth={992}>
        <CustomSelect
          ref={ref}
          label={proxyTypeLabel}
          options={filteredProxies.map((proxyType) => ({ ...proxyType, label: getProxyTypeName(proxyType) }))}
          placeholder={""}
          changeFunc={mobileHandler}
        />
      </MediaQuery>
    </>
  );
};
